/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';
import { KEEP_SESSION_INTERVAL_IN_SEC, ERRORS } from '@/utils/constants';
import { log } from '@/utils/common';
import auth from '@/apis/auth';
import recommendation from './modules/recommendation';
import product from './modules/product';
import survey from './modules/survey';
import common from './modules/common';
import notice from './modules/notice';
import agreement from './modules/agreement';
import context from './modules/context';
import account from "@/store/modules/account";
import creditcard from "@/store/modules/creditcard";
import creditcardbilling from "@/store/modules/creditcardbilling";
import quickaccountbilling from "@/store/modules/quickaccountbilling";
import receipt from "@/store/modules/receipt";
import delivery from "@/store/modules/delivery";
import order from "@/store/modules/order";
import pickup from "@/store/modules/pickup";
import amwaypay from "@/store/modules/amwaypay";
import terms from '@/store/modules/terms';
import payment from '@/store/modules/payment';
import { TEMP_USERS } from '../dev/misc';
import orderApi from '@/apis/order';


Vue.use(Vuex);

// global ready state promise

let _intervalHandle = null;
let _resolve = null;
let _reject = null;
const globalReadyStatePromise = new Promise((resolve, reject) => {
    _resolve = resolve;
    _reject = reject;
});

function redirectToLogin() {
    window.location.href = `https://${process.env.SSO_HOST}/login`;
}

export default new Vuex.Store({
    modules: {
      recommendation,
      product,
      survey,
      agreement,
      context,
      common,
      notice,
      account,
      creditcard,
      creditcardbilling,
      quickaccountbilling,
      delivery,
      receipt,
      order,
      pickup,
      amwaypay,
      terms,
      payment,
    },
    state: {
      ssoToken: "",
      userInfo: null,
      isLogin: false,
      floatingButtons: false,

      lastError: {
          exists: false,
          handled: false,
          msgs: [],
          errors: [],
      },
      asyncLoading: false,
      appReadyState: globalReadyStatePromise,
    },
    mutations: {
      floatingButtons(state, value) {
        state.floatingButtons = value
      },
      updateSsoToken(state, value = "") {
        console.log("Update SSO Token CALLED")
        state.ssoToken = value;
      },
      // 로그인이 성공
      login(state, payload) {
          state.isLogin = payload.state;
      },
      userInfo(state, payload) {
          state.userInfo = payload;
      },

      lastErrorHandled(state) {
          state.lastError.handled = true;
      },
      newError(state, payload) {
          const { lastError } = state;
          if (!lastError.exists || lastError.handled) {
              lastError.exists = true;
              lastError.handled = false;
              lastError.msgs = [payload.msg];
              lastError.errors = [payload.error];
          } else {
              lastError.msgs.push(payload.msg);
              lastError.errors.push(payload.error);
          }
      },
      asyncLoading(state, flag) {
          state.asyncLoading = flag;
      },
    },
    actions: {
      // 로그인 시도
      // eslint-disable-next-line no-unused-vars
      async ssoLogin({ commit }) {
          log('store::ssoLogin', process.env.NODE_ENV);
          if (process.env.NODE_ENV === 'development1') {x
              commit('login', {
                  state: true,
              });
              commit('userInfo', TEMP_USERS.USER2);
              _resolve();
              return;
          }

          try {
              const result = await auth.ssoLogin();
              log('store::ssoLogin', 'sso success', result);
              commit('login', {
                  state: true,
              });
              commit('userInfo', {
                  userId: result.loginId,
                  name: result.name,
                  cUid: result.customerUid,
                  bizNature: result.bizNature
              });

              _resolve();

              // session 유지
              if(!_intervalHandle) {
				auth.keepSession(false);
                console.log("### start keepSession interval ###");
                _intervalHandle = setInterval(() => {
                    auth.keepSession(true);
                }, KEEP_SESSION_INTERVAL_IN_SEC);
              }
          }
          catch (error) {
              log('store::ssoLogin', error.message, error);

              commit('login', {
                  state: false,
              });
              clearInterval(_intervalHandle);

              // _reject();

              redirectToLogin();
          }
      },
      async ssoToken({commit}) {
        const ssoToken = await auth.getSsoToken();
        console.log("Store::ssoToken", ssoToken);
        if (ssoToken !== undefined && typeof ssoToken === "string") {
          commit('updateSsoToken', ssoToken);
        }
      },

      handleLastError({ commit }) {
          commit('lastErrorHandled');
      },
      newError({ commit }, error) {
          commit('newError', {
              msg: error.msg,
              error: error.error,
          });
      },
      showSpinner({ commit }) {
          commit('asyncLoading', true);
      },
      hideSpinner({ commit }) {
          commit('asyncLoading', false);
      },
      resetOrderInfo({commit}) {
        commit('account/reset');
        commit('amwaypay/reset');
        commit('creditcard/reset');
        commit('creditcardbilling/reset');
        commit('quickaccountbilling/reset');
        commit('delivery/reset');
        commit('order/reset');
        commit('pickup/reset');
        commit('receipt/reset');
        commit('payment/reset');
      },
    },
    getters: {
      floatingButtons: state => state.floatingButtons,
      lastError: (state) => state.lastError,
      userId: (state) => state.userInfo.userId,
      cuid: (state) => state.userInfo.cUid,
      bizNature: (state) => state.userInfo.bizNature,
      asyncLoading: (state) => state.asyncLoading,
      appReadyState: (state) => state.appReadyState,
      ssoToken: (state) => state.ssoToken,
    },
});

window.addEventListener('beforeunload', () => {
    if (_intervalHandle) {
      console.log("### clear keepSession interval ###");
      clearInterval(_intervalHandle);
      _intervalHandle = null;
    }
  });



// WEBPACK FOOTER //
// ./src/store/index.js